import { render, staticRenderFns } from "./BankAccountsTable.vue?vue&type=template&id=6e063afe"
import script from "./BankAccountsTable.vue?vue&type=script&lang=js"
export * from "./BankAccountsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports